// extracted by mini-css-extract-plugin
export default {"napsaLog-header":"Header_napsaLog-header__T5UbA","napsaLog-header-item":"Header_napsaLog-header-item__B0dye"};